import { Stack, Button, Container, Typography } from '@mui/material';

import { WifiOffIcon } from 'src/assets/icons';

function OfflinePage() {
  return (
    <Container
      maxWidth="sm"
      sx={{
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack spacing={8} alignItems="center">
        <WifiOffIcon sx={{ width: 140, height: 140 }} />
        <Stack spacing={6} alignItems="center">
          <Stack>
            <Typography variant="h6">WHOOPS!</Typography>
            <Typography variant="body2" color="text.secondary">
              Slow or no Internet connection. Please check your Internet settings.
            </Typography>
          </Stack>
          <Button color="primary" variant="contained" sx={{ width: 'fit-content' }}>
            Retry
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}

export default OfflinePage;
